



























import Vue from 'vue';
export default Vue.extend({
  name: 'CatalisadoresCatalogoDialogAviso',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
});
